/**
 * Shared Documents components.
 *
 * `AIImportZone` went with the card-grid renderer VALE-900 retired — the "One
 * list" surface carries its own drop target — and `DocumentActions` outlived
 * the same retirement only because a Storybook prototype still mounts it; the
 * live tab's menu is `one-list/document-row-actions.tsx`.
 */

export { CertifiedBadge } from './certified-badge';
export { DocumentCertifiedBadge } from './document-certified-badge';
export { DocumentThumbnail } from './document-thumbnail';
export { DocumentActions } from './document-actions';
